// extracted by mini-css-extract-plugin
export default {"orderService":"OrderService_orderService__e3fi3","visitDate":"OrderService_visitDate__dUwmL","timeSlot":"OrderService_timeSlot__q3MwJ"};